import { Skeleton } from 'antd';
import { Common } from '@stockbit/ui';

const { Flex } = Common;

function SkeletonList() {
  const listItem = new Array(3).fill(0);
  return (
    <Flex
      direction="column"
      justify="center"
      align="center"
      width="100%"
      style={{ gap: 10 }}
    >
      {listItem.map((_, idx) => (
        <Skeleton.Input
          key={`watchlist-skeleton-${idx}`}
          active
          size="small"
          style={{ width: 470, height: '30px' }}
        />
      ))}
    </Flex>
  );
}

export default SkeletonList;
